<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Bid Amount</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" type="text" v-model="max_bid_amount" placeholder="Max bid amount" :class="{ 'is-danger': errors.max_bid_amount }">
                    <span class="icon is-left">
                        <i class="fas fa-gavel"></i>
                    </span>
                    <p v-if="errors.max_bid_amount" class="help is-danger">{{ errors.max_bid_amount[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                countries: []
            }
        },
        computed: {
            max_bid_amount: {
                get() {
                    return this.$store.getters.getNewPricePlan.max_bid_amount
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'max_bid_amount', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/BidAmountInput.vue